export default function initialState() {
  return {
    files: {},
    filesById: [],
    filteredFiles: {}
  };
}
